import React from 'react';
import get from 'lodash/get';
import cs from 'classnames';
import {connect} from 'react-redux';

import DropDown from '~/components/common/DropDown';
import LabeledInput from '~/components/common/LabeledInput';
import {MenuListItem} from '~/components/common/MenuList';
import debounce from '~/misc/debounce';
import mapDispatch from '~/misc/mapDispatch';
import {geosearch, selectPlace, checkAndShow, updateCriteria} from '~/modules/geosearch/actions';

import css from './index.css';

const dataQa = (prefix, postfix) => {
  if (!prefix) {
    return null;
  }
  return `geosearch-${prefix}-${postfix}`;
};

const matched = (array) => {
  if (!array || !array.length) {
    return <span/>;
  }
  return array.map((i, num) => (
    <span key={num}
      className={cs(i.isMatched && css.matched)}
      data-qa={i.isMatched ? 'location-matched-string' : null}
    >{i.value}</span>
  ));
};

const itemTitle = (item) => (
  <span className={css.title}>
    <span className={css.mainPart} data-qa='location-main-part'>
      {matched(item.nameParts.main)}
      <span>{item.nameParts.rest.length ? ',' : ''}</span>

    </span>
    <span className={css.restBlock} data-qa='location-rest-part'>
      {item.nameParts.rest.map((part, num) => (
        <span key={num} className={css.restPart}>
          <span>{matched(part)}</span>
          <span>{item.nameParts.rest[num + 1] ? ',' : null}</span>
        </span>
      ))}
    </span>
  </span>
);

class LocationInput2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      touched: false,
      isChange: false
    }
    this.handleClick = this.handleClick.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.search = debounce((id, value) => this.props.geosearch(value), 200);
  }

  render() {
    const prefix = this.props['data-qa'];
    let value = !this.state.isChange ? get(this.props, 'searchedCity', '') ||  get(this.props, 'data.placeValue.name', '') || get(this.props, 'data.from_state_name', '') : get(this.props, 'data.placeValue.name', '')
    return (
      <div className={cs(this.props.wrapClassName)} data-qa={prefix}>
        <DropDown
          allowKeyboard={true}
          data-qa={dataQa(prefix, 'dropdown')}
          id={this.props.id}
          wrapClassName={css.wrapDropdown}
          dropDownClassName={css.dropdown}
          manualControl={true}
          trigger={
            <LabeledInput
              {...this.props.input}
              autoFocus={this.props.autoFocus}
              data-qa={dataQa(prefix, 'input')}
              label={this.props.label}
              icon={this.props.icon}
              iconLeft={this.props.iconLeft}
              name={this.props.name ? this.props.name : ''}
              value={value}
              mediumInput
              onChange={this.handleInput}
              placeholder={get(this.props, 'placeholder', 'Anywhere')}
              onBlur={this.handleBlur}
              onFocus={this.handleFocus}
              error={this.props.error || this.state.touched || ' '}
              touched={this.props.touched || null}
              autoComplete = {this.props.autoComplete}
              inputClassName={this.props.inputClassName}
            />
          }
          closeByClick={true}
          content={this.renderSelect()}
          onKeyPress={this.onKeyPress}
        />
      </div>
    );
  }

  renderSelect() {
    const data = get(this, 'props.data.search', {});
    const menu = (id) => {
      const array = get(data, [id, 'list']);

      if (!array || !array.length) {
        return (<span/>);
      }
      return (
        <div className={css.listGroup} data-qa={`georesults-${id}`}>
          {array.map((i, num) => (
            <MenuListItem
              cutText={true}
              data-qa={`suggest-item-${num}`}
              key={i.id}
              name={this.props.name ? this.props.name : ''}
              data={`${id}:${num}`}
              onMouseDown={this.handleClick}
              title={itemTitle(i)}
            />
          ))}
        </div>
      );
    };

    const prefix = this.props['data-qa'];

    return (
      <div className={cs(css.list)} data-qa={`${prefix}-suggests`}>
        {menu('us')}
        {menu('ca')}
      </div>
    );
  }

  handleInput(event) {
    if (!this.state.isChange) {
      this.setState({isChange: true})
    }
    this.props.updateCriteria(event.target.value);
    this.props.checkAndShow(true);
    this.search(this.props.id, event.target.value);
    if (this.props.onChange) {
      this.props.onChange(this.props);
    }
  }

  handleClick(event) {
    const idString = event.currentTarget.getAttribute('data-value');
    if(this.props.onBlur){
      const cbFunc = () => {
        this.props.onBlur(this.props);
      };
      this.props.selectPlace({idString: idString, cb: cbFunc});
    } else {
      this.props.selectPlace({idString: idString});
    }
  }

  handleFocus(ev, autoFocused) {
    this.props.checkAndShow(!autoFocused);
  }

  handleBlur() {
    this.props.checkAndShow(false);
    if (this.props.limit) {
      this.props.onChange(this.props.data.placeValue ? this.props.data.placeValue.name : '');
    }
    this.setState({touched: true});
    if (this.props.onBlur) {
      this.props.onBlur(this.props);
    }
  }
}

export default connect((state, props) => ({
  data: state.geosearch[props.id] || {},
}), mapDispatch({
  checkAndShow: ({id}, isFocused) => checkAndShow(id, isFocused),
  geosearch: ({id}, value) => geosearch(id, value),
  selectPlace: ({id}, {idString, cb}) => {
    const parts = idString.split(':');
    const country = parts[0];
    const num = parts[1];
    return selectPlace(id, country, num, cb);
  },
  updateCriteria: ({id}, criteria) => updateCriteria(id, criteria),
}))(LocationInput2);



// WEBPACK FOOTER //
// ./src/components/common/LocationInput2/index.js